import { resolveThemeColor } from './themeColors'

const ROTATION_HANDLE_OFFSET_PX = 18
const ROTATION_HANDLE_SIZE_PX = 24

function renderRotationHandle(ctx, left, top, _styleOverride, object) {
  const angle = ((Number(object?.angle) || 0) * Math.PI) / 180
  ctx.save()
  ctx.translate(left, top)
  ctx.rotate(angle)
  ctx.beginPath()
  ctx.arc(0, 0, ROTATION_HANDLE_SIZE_PX / 2, 0, Math.PI * 2)
  ctx.fillStyle = resolveThemeColor('--color-accent')
  ctx.fill()
  ctx.strokeStyle = resolveThemeColor('--color-base')
  ctx.lineWidth = 2
  ctx.stroke()

  ctx.strokeStyle = resolveThemeColor('--color-base')
  ctx.lineWidth = 2
  ctx.lineCap = 'round'
  ctx.lineJoin = 'round'
  ctx.beginPath()
  ctx.arc(0, 0, 5, -Math.PI * 0.8, Math.PI * 0.55)
  ctx.stroke()
  ctx.beginPath()
  ctx.moveTo(4.8, 2.2)
  ctx.lineTo(5.8, 6.2)
  ctx.lineTo(1.8, 5.2)
  ctx.stroke()
  ctx.restore()
}

export function makeRotationHandleVisible(object) {
  const source = object?.controls?.mtr
  if (!source) return

  const rotationControl = Object.assign(
    Object.create(Object.getPrototypeOf(source)),
    source,
    {
      offsetY: ROTATION_HANDLE_OFFSET_PX,
      sizeX: ROTATION_HANDLE_SIZE_PX,
      sizeY: ROTATION_HANDLE_SIZE_PX,
      touchSizeX: 32,
      touchSizeY: 32,
      withConnection: false,
      render: renderRotationHandle,
    }
  )
  object.controls = { ...object.controls, mtr: rotationControl }
}


